import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import IconButton from '@mui/material/IconButton'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { FC, MouseEvent, useState } from 'react'
import ShareIcon from './../../../../assets/icons/Share.svg?react'

import { useLocation } from 'react-router-dom'
import { RequestArchiveDialog } from '../../../../dialogs/RequestArchiveDialog'
import { RequestDeteleDialog } from '../../../../dialogs/RequestDeteleDialog'
import { ShareDialog } from '../../../../dialogs/ShareDialog/ShareDialog'
import { useDialogStore } from '../../../../store/storeDialog'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { ThreadDTO, ThreadShortDTO } from '../../../../swagger/dto'
import { RequestRenameDialog } from '../dialog/RequestRenameDialog'
import CalendarArrowUpIcon from './../../../../assets/icons/CalendarArrowUp.svg?react'
import PenIcon from './../../../../assets/icons/PenIcon.svg?react'

type Props = {
    request: ThreadShortDTO | ThreadDTO
}

export const RequestItemMenu: FC<Props> = ({ request }) => {
    const { pathname } = useLocation()

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [openArchiveDialog, setOpenArchiveDialog] = useState<boolean>(false)
    const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false)
    const [openRenameDialog, setOpenRenameDialog] = useState<boolean>(false)
    const [openShareDialog, setOpenShareDialog] = useState<boolean>(false)
    const { updateThread } = useDialogStore()
    const { setOpenRegularRequestsDialogThreadId, isTempUser } = useWrapperStore((state) => state)

    const open = Boolean(anchorEl)

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setOpenRemoveDialog(false)
        setOpenArchiveDialog(false)
        setOpenRenameDialog(false)
        setAnchorEl(null)
    }

    const handleClickOpenRemoveDialog = () => {
        setOpenRemoveDialog(true)
    }

    const handleClickOpenArchiveDialog = () => {
        setOpenArchiveDialog(true)
    }

    const handleClickOpenRequestRenameDialog = () => {
        setOpenRenameDialog(true)
    }

    const handleClickOpenShareDialog = () => {
        setOpenShareDialog(true)
    }

    const handleClickCloseShareDialog = () => {
        setOpenShareDialog(false)
    }

    const handleCopy = () => {
        if (request.shared) {
            return
        }

        updateThread({ threadId: request.id }, { shared: true })
    }

    const handleOpenRegularRequests = () => {
        setOpenRegularRequestsDialogThreadId(request.id)
        handleClose()
    }

    return (
        <>
            <IconButton
                sx={{
                    '&:hover': { borderColor: '#F4F4F6' },
                    position: 'relative',
                    background: ' #fff',
                    zIndex: 1000,
                }}
                variant="text"
                color="primary"
                aria-expanded={open ? 'true' : undefined}
                onClick={(e) => handleClick(e)}>
                <MoreVertOutlinedIcon />
            </IconButton>
            {request && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}>
                    {!request.is_archived && (
                        <MenuItem onClick={handleClickOpenRequestRenameDialog}>
                            <ListItemText
                                primary={
                                    <Typography variant="body" color="#5A5F72">
                                        Переименовать
                                    </Typography>
                                }
                            />
                            <PenIcon color="#5A5F72" />
                        </MenuItem>
                    )}

                    <MenuItem onClick={handleClickOpenArchiveDialog}>
                        <ListItemText
                            primary={
                                <Typography variant="body" color="#5A5F72">
                                    {request.is_archived ? 'Разархивировать' : 'Архивировать'}
                                </Typography>
                            }
                        />
                        <Inventory2OutlinedIcon fontSize="small" sx={{ color: '#5A5F72' }} />
                    </MenuItem>

                    {!request.is_archived &&
                    (pathname === '/requests' || pathname === '/project') ? (
                        <MenuItem onClick={handleClickOpenShareDialog}>
                            <ListItemText
                                primary={
                                    <Typography variant="body" color="#5A5F72">
                                        Поделиться
                                    </Typography>
                                }
                            />
                            <ShareIcon color="#5A5F72" />
                        </MenuItem>
                    ) : null}

                    {!request.is_archived && !isTempUser && (
                        <MenuItem onClick={handleOpenRegularRequests}>
                            <ListItemText
                                primary={
                                    <Typography variant="body" color="#5A5F72">
                                        Регулярные запросы
                                    </Typography>
                                }
                            />
                            <CalendarArrowUpIcon color="#5A5F72" />
                        </MenuItem>
                    )}

                    <MenuItem onClick={handleClickOpenRemoveDialog}>
                        <ListItemText
                            primary={
                                <Typography variant="body" color="#CA1616">
                                    Удалить
                                </Typography>
                            }
                        />
                        <DeleteOutlinedIcon fontSize="small" style={{ color: '#CA1616' }} />
                    </MenuItem>
                </Menu>
            )}

            {openRemoveDialog && request && (
                <RequestDeteleDialog
                    open={openRemoveDialog}
                    handleClose={handleClose}
                    id={request.id}
                />
            )}
            {openArchiveDialog && request && (
                <RequestArchiveDialog
                    open={openArchiveDialog}
                    handleClose={handleClose}
                    theadDetail={request}
                />
            )}

            {openRenameDialog && request && (
                <RequestRenameDialog
                    request={request}
                    open={openRenameDialog}
                    handleClose={handleClose}
                />
            )}

            <ShareDialog
                open={openShareDialog}
                onClose={handleClickCloseShareDialog}
                entityId={request.id}
                entityName="thread"
                onCopy={handleCopy}
            />
        </>
    )
}
